import React from 'react';
import ContentHighlighter from '../../content-highlighter/ContentHighlighter';
import { IconContainer, BenefitsCheckListElementContainer } from './BenefitsChecklistElement.style';

interface Props {
  icon?: () => React.ElementType;
  text: string;
  bolded: string;
  breakPoint?: string;
}

const BenefitsChecklistElement = (props: Props) => {
  const Icon = props.icon ? props.icon() : null;

  return (
    <BenefitsCheckListElementContainer breakPoint={props.breakPoint}>
      <IconContainer>
        <>
          {Icon}
          <ContentHighlighter text={props.text} bolded={props.bolded} />
        </>
      </IconContainer>
    </BenefitsCheckListElementContainer>
  );
};

export default BenefitsChecklistElement;
